<template>
  <contract-detail>
    <template v-slot:title>{{ $route.params.type }}契約</template>

    <template v-slot:cancel>
      <v-btn small class="t-btn--red-dark" @click="$windowClose">
        <v-icon>mdi-close</v-icon>
        <span>&emsp;閉じる</span>
      </v-btn>
    </template>

    <template v-slot:send>
      <v-btn
        small
        class="t-btn--prm ml-3"
        @click="actionUpdate()"
        :disabled="!checkPerUser"
      >
        保存
      </v-btn>
    </template>

    <template v-slot:default>
      <v-card class="pa-5 ma-5" color="#FFFFFF">
        <div class="mb-2">
          <span class="text-title-component font-weight-bold">
            SPポイント利用制限
          </span>
        </div>
        <v-checkbox
          class="checkbox-custom mt-0 pt-0"
          hide-details
          label="ポイント利用不可"
          :input-value="getRestrictPoint"
          @change="setRestrictPoint"
          :disabled="!checkPerUser"
          slim
        ></v-checkbox>
      </v-card>
    </template>
  </contract-detail>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import contractDetail from '../../ContractDetail.vue';
import { checkPermissionUserCurrent } from '@/utils/permissions';
import router from '@/router';

export default {
  name: 'ContractPointRestrict',
  components: { contractDetail },
  data() {
    return {
      checkPerUser: checkPermissionUserCurrent(this.$router.currentRoute),
    };
  },
  computed: {
    ...mapGetters(['getBasicInfors', 'getRestrictPoint']),
  },
  watch: {
    getBasicInfors(val) {
      if (val && typeof val.pointRestricted === 'boolean') {
        this.setRestrictPoint(val.pointRestricted);
      }
    },
  },
  mounted() {
    this.basicInformationList(router.currentRoute.params.id);
  },
  methods: {
    ...mapActions(['basicInformationList', 'updateContractRestrictPoint']),
    ...mapMutations(['setRestrictPoint']),
    actionUpdate() {
      this.updateContractRestrictPoint();
    },
  },
};
</script>

<style lang="scss" scoped>
.text-title-component {
  font-size: 20px;
  color: #004f8b;
  font-weight: bold;
}
.t-btn--prm,
.t-btn--red-dark {
  font-size: 14px !important;
  height: 32px !important;
}
</style>
